var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline ml-2"},[_vm._v("\n    "+_vm._s(this.min)+":"+_vm._s(this.sec)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }